<template>
    <form @submit.prevent="save" class="py-4">
        <div class="w-full py-6 md:py-4 px-6 md:px-8 border border-additional-text rounded-lg bg-white" >
          <p v-if=" newPlace" class=" text-lg font-bold mb-4">Добавление <br> заведения</p>
            <div class="flex relative"  @click="show = true">

                <h2 class="flex-1 flex" @click="show = true">
                    <div>
                      <p v-if="mobile && show" class="md:text-sm text-10px text-additional-text font-bold">Название заведения</p>
                      <div v-if="!nameChanging"><span class="text-main-text text-sm md:text-lg " v-text="form.name"></span><img  v-if="show && !newPlace" class="ml-3 w-4 h-4"  @click="nameChanging = true" src="../../../assets/SVG/pencil.svg"/></div>
                      <div v-else><input v-model="form.name" @blur="nameChanging = false" class="text-base border-b text-main-text mr-10 w-48 font-bold outline-none border-additional-text focus:border-select-box-brand-light"  type="text"></div>

                    </div>
                    <!-- <div v-else class="py-2 ">
                        <p class="text-10px text-additional-text font-bold">Название заведения</p>
                          <div class="flex flex-row pt-4">
                              <input v-model="form.name" ref="namePlace" @blur="nameChanging = false"
                                     class="-mt-3 text-base border-b text-main-text  w-full font-bold outline-none border-additional-text focus:border-select-box-brand-light"
                              />
                          </div>
                    </div> -->
                    <span class="hidden text-main-text text-sm md:text-lg" v-if="!form.name && newPlace">Добавить заведение</span>
                    <span class="hidden text-main-text text-sm md:text-lg" v-if="!form.name && !newPlace">Поле "заведение" не заполнено</span>
                </h2>
                <div class="flex flex-row ">
                    <div class="hidden md:flex flex-row items-center mr-8" v-if="form.type && !newPlace">
                        <p class="absolute pin-r mr-60 text-main-text text-sm font-semibold ">Тип закрытия регистрации:&nbsp; </p>
                        <p class="absolute pin-r mr-28 text-brand-light text-sm font-semibold w-32">{{newPlaceType[form.type].name}}</p>
                    </div>
                    <font-awesome-icon :icon="['far', 'trash-alt']" v-if="!item.hasEventDays&&show"
                                       :disabled="form.processing"
                                       class="my-auto hidden md:flex justify-end cursor-pointer text-xl text-grey-dark"

                                      @click.prevent.stop="deletePlace"></font-awesome-icon>
                    <font-awesome-icon
                            v-if="!newPlace"
                            :icon="['far', 'angle-down']"
                            size="2x"
                            :class="rotateArrow"
                            fixed-width
                            class="arrow mt-2 md:mt-0 w-3 h-3 md:h-8 md:w-8 text-menu-inactive-gray-light cursor-pointer ml-6"
                            @click.prevent.stop="show = !show"
                    ></font-awesome-icon>
                    <!--<delete-place :newPlace="newPlace" @disableInput="disableInput = !disableInput" @deletePlace="deletePlace" class="flex items-center"></delete-place>-->
                </div>

            </div>

            <div class="flex flex-col md:flex-row md:pt-6" v-if="show">
                <div class="flex-1 flex flex-col md:flex-row w-full">
                   <div class="flex flex-col md:flex-col md:w-3/5">
                        <!-- <div class="flex flex-col">
                            <div class="py-2">
                                <p class="md:text-sm text-10px text-additional-text font-bold">Название заведения</p>
                                <div class="flex flex-row pt-4">
                                    <input v-model="form.name"
                                           class="-mt-3 border-b text-main-text mr-10 w-full font-bold outline-none border-additional-text focus:border-select-box-brand-light"
                                    />
                                </div>
                            </div>
                            <span v-if="form.errors.has('name')"
                                  class="text-red text-xs" v-text="form.errors.first('name')"
                            ></span>
                        </div> -->
                        <div class="flex flex-col mt-4 md:mt-0">
                            <div class="md:py-2 ">
                                <p class="text-10px md:text-sm font-bold text-additional-text mt-3">Адрес заведения</p>
                                <div class="flex flex-row pt-1">
                                    <input v-model="form.address"
                                           class="border-b text-sm md:text-base text-main-text mr-10 w-full font-bold outline-none border-additional-text focus:border-select-box-brand-light"
                                    />
                                </div>
                            </div>
                            <span v-if="form.errors.has('address') || false"
                                  class="text-red text-xs" v-text="form.errors.first('address')"></span>
                        </div>
                        <div class=" flex-col md:w-2/5 mr-16 mt-4 md:mt-0 hidden">
                        <p v-show="form.type ? form.type.length : null" class="text-10px md:text-sm text-additional-text font-bold pt-2">Тип закрытия регистрации</p>
                        <selectbox v-if="newPlace" @input="place_setting"
                                   placeholder="Тип закрытия регистрации"
                                   class="font-bold text-menuOrder-dark-blue pr-5 whitespace-no-wrap"
                                   :list-items="newPlaceType" v-model="form.type"
                        ></selectbox>
                        <p v-show="!newPlace && form.type ? !form.type.length : null" class="text-10px md:text-sm text-additional-text font-bold pt-2">Тип закрытия регистрации</p>
                        <selectbox v-if="!newPlace" @input="place_setting"
                                   placeholder="Тип закрытия регистрации"
                                   class="font-bold text-menuOrder-dark-blue pr-5 whitespace-no-wrap"
                                   :list-items="oldPlaceType" v-model="form.type"
                        ></selectbox>
                        </div>
                         <div class="pb-2 pt-5 w-full hidden md:block" >
                            <p class="text-10px md:text-sm text-additional-text font-bold">Максимально игроков в команде</p>
                            <div class="flex flex-row pt-1">
                                <input v-model="form.max_team_players"
                                       class="border-b text-sm md:text-base text-main-text mr-10 w-12 font-bold outline-none border-additional-text focus:border-select-box-brand-light team-input"
                                />
                            </div>
                            <span v-if="form.errors.has('max_team_players')"
                                  class="text-red text-xs"
                                  v-text="form.errors.first('max_team_players')"
                            ></span>
                        </div>
                    </div>
                    </div>
                    <div class="md:flex flex-col md:w-2/5 mr-16 mt-4 md:mt-0 ">
                        <p v-show="form.type ? form.type.length : null" class="text-10px md:text-sm text-additional-text font-bold pt-2">Тип закрытия регистрации</p>
                        <selectbox v-if="newPlace" @input="place_setting"
                                   placeholder="Тип закрытия регистрации"
                                   class="font-bold text-menuOrder-dark-blue pr-5 whitespace-no-wrap"
                                   :list-items="newPlaceType" v-model="form.type"
                        ></selectbox>
                        <p v-show="!newPlace && form.type ? !form.type.length : null" class="text-10px md:text-sm text-additional-text font-bold pt-2">Тип закрытия регистрации</p>
                        <selectbox v-if="!newPlace" @input="place_setting"
                                   placeholder="Тип закрытия регистрации"
                                   class="font-bold text-menuOrder-dark-blue pr-5 whitespace-no-wrap"
                                   :list-items="oldPlaceType" v-model="form.type"
                        ></selectbox>
                          <div class="pb-2 pt-5 w-full" v-if="form.type === 'team'">
                            <p class="text-10px md:text-sm text-additional-text font-bold">Количество команд</p>
                            <div class="flex flex-row pt-1">
                                <input v-model="form.team_capacity"
                                       class="border-b text-sm md:text-base text-main-text mr-10 w-12 font-bold outline-none border-additional-text focus:border-select-box-brand-light team-input"
                                />
                            </div>
                            <span v-if="form.errors.has('team_capacity')"
                                  class="text-red text-xs"
                                  v-text="form.errors.first('team_capacity')"
                            ></span>
                        </div>
                          <div class=" pt-5 w-full" v-if="form.type === 'people'">
                            <p class="text-10px md:text-sm text-additional-text font-bold">Количество игроков</p>
                            <div class="flex flex-row pt-1">
                                <input v-model="form.people_capacity"
                                       class="border-b  text-main-text mr-10 w-12 font-bold outline-none border-additional-text focus:border-select-box-brand-light team-input"
                                />
                            </div>
                            <span v-if="form.errors.has('people_capacity')"
                                  class="text-red text-xs"
                                  v-text="form.errors.first('people_capacity')"
                            ></span>
                        </div>
                            <div class="pb-2 pt-5 w-full md:hidden" >
                            <p class="text-10px md:text-sm text-additional-text font-bold">Максимально игроков в команде</p>
                            <div class="flex flex-row pt-1">
                                <input v-model="form.max_team_players"
                                       class="border-b text-sm md:text-base text-main-text mr-10 w-12 font-bold outline-none border-additional-text focus:border-select-box-brand-light team-input"
                                />
                            </div>
                            <span v-if="form.errors.has('max_team_players')"
                                  class="text-red text-xs"
                                  v-text="form.errors.first('max_team_players')"
                            ></span>
                        </div>

                </div>
                <div class="" v-if="false">
                    <div class="py-2">
                        <p class="text-10px md:text-xs font-semibold">Кол-во столов/Кол-во мест за столом</p>
                        <div v-for="(table, index) in form.table_types" :key="table.uuid || uuid()"
                             class="flex -mx-1 py-2">
                            <div class="px-1">
                                <img class="w-4" src="@/assets/icons/table.svg">
                            </div>
                            <div class="px-1 flex-1">
                                <input v-model="form.table_types[index].table_count" type="number"
                                       class="border-b border-select-box-brand-light text-menuOrder-dark-blue mr-10 w-full font-bold outline-none"/>
                                <span v-if="form.errors.has(`table_types.${index}.table_count`)"
                                      class="text-red text-xs"
                                      v-text="form.errors.first(`table_types.${index}.table_count`)"
                                ></span>
                            </div>
                            <div class="px-1">
                                <img class="w-4" src="@/assets/icons/user.svg">
                            </div>
                            <div class="px-1 flex-1">
                                <input v-model="form.table_types[index].seat_count" type="number"

                                       class="border-b border-select-box-brand-light text-menuOrder-dark-blue mr-10 w-full font-bold outline-none"/>
                                <span v-if="form.errors.has(`table_types.${index}.seat_count`)"
                                      class="text-red text-xs"
                                      v-text="form.errors.first(`table_types.${index}.seat_count`)"
                                ></span>
                            </div>
                            <div>
                                <button @click.prevent="removeAdvertisement(index)"
                                        class="hover-up outline-none rounded-full flex flex-row justify-center
                                    items-center h-6 w-6 ml-6 -mt-0  bg-red">
                                    <font-awesome-icon class="text-xs text-center text-white "
                                                       :icon="['far', 'trash-alt']"></font-awesome-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="pt-4">
                        <button class="outline-none flex items-center"
                                @click.prevent="addTable">
                            <div class="outline-none rounded-full flex justify-center items-center h-8 w-8 bg-brand-light">
                                <font-awesome-icon class="text-white text-xl"
                                                   :icon="['fal', 'plus']">
                                </font-awesome-icon>
                            </div>

                            <div class="text-xs text-additional-text font-bold ml-4">Добавить вид стола</div>
                        </button>
                    </div>
                </div>
                <!--<div class="flex-1"></div>--->
            </div>
            <div v-if="!item.hasEventDays&&mobile&&show" @click.prevent.stop="deleteConfirm = true" class="flex items-center mt-5">
              <img class="w-3 h-3 mr-2" src="@/assets/SVG/trash-bin.svg" alt="">
              <p class="underline text-10px">
                Удалить заведение
              </p>
           </div>
            <div class="flex mt-4" v-if="show">
                <button :disabled="form.processing" v-if="newPlace" class="ml-auto outline-none justify-center hover-up font-bold bg-brand-light text-white text-white rounded-full py-3 w-full md:w-50">
                    Добавить
                </button>
                <button :disabled="form.processing" v-if="!newPlace" class="ml-auto outline-none justify-center hover-up font-bold bg-brand-light text-white text-white rounded-full py-3 w-full md:w-50">
                    Сохранить
                </button>
            </div>
        </div>
          <ConfirmModal v-if="deleteConfirm" @close="deleteConfirm = false" class="">
            <p class="text-sm font-bold text-center mt-12">
                Вы уверены, что хотите удалить заведение?
            </p>
            <div @click="deletePlace" class="button-reg-modal black-border mt-8">
             <p >Удалить</p>
            </div>
            <div @click="deleteConfirm = false"  class="button-reg-modal mt-4 mb-10 yellow ">
            <p>Отменить</p>
            </div>
          </ConfirmModal>
    </form>
</template>
<script>
import { mapActions } from 'vuex';
import Form from 'form-backend-validation';
import client from '@/clients/partners';
import uuid from 'uuid/v4';
import DeletePlace from './delete-place.vue';
import Selectbox from '../selectbox';
import ConfirmModal from '../current-registration/registration-layout/registration-modal.vue';

export default {
  name: 'Place',
  components: { Selectbox, DeletePlace, ConfirmModal },
  props: ['item'],

  created() {
    this.form.populate(this.item);


    if (this.item.id === undefined) {
      this.show = true;
      this.newPlace = true;
      this.nameChanging = true;
    }

    // if (!this.form.type) {
    //   this.form.type = 'team'
    // }
  },

  updated() {
    console.log('Updated');
  },

  data() {
    return {
      form: new Form({
        name: '',
        address: '',
        type: [],
        team_capacity: '',
        people_capacity: '',
        max_team_players: '',
      }, {
        http: client,
      }),
      show: false,
      nameChanging: false,
      newPlace: false,
      place_setting: '',
      deleteConfirm: false,
      newPlaceType: {
        team: {
          id: 1,
          name: 'По командам',
        },
        people: {
          id: 2,
          name: 'По игрокам',
        },
      },
      oldPlaceType: {
        team: {
          id: 1,
          name: 'По количеству команд',
        },
        people: {
          id: 2,
          name: 'По количеству игроков',
        },
      },
    };
  },
  watch: {
    'form.type': function () {
      this.form.team_capacity = '';
      this.form.people_capacity = '';
    },
    show() {
      this.form.populate(this.item);
      if (this.form.table_types === null) {
        this.form.table_types = [];
      }
    },
  },

  methods: {
    ...mapActions(['selectShowModal']),
    ...mapActions(['selectModalText']),
    removeAdvertisement(index) {
      this.form.table_types.splice(index, 1);
    },
    uuid,
    addTable() {
      this.form.table_types.push({
        uuid: uuid(),
        table_count: 0,
        seat_count: null,
      });
    },

    save() {
      let request = null;
      if (this.newPlace) {
        request = this.form.post('/places');
        this.selectModalText('Добавлено новое место');
      } else {
        request = this.form.put(`/places/${this.item.id}`);
        this.selectModalText('Место изменено');
      }
      request.then(() => {
        this.show = false;
        this.selectShowModal(true);
        this.$emit('saved');
      });
    },
    deletePlace() {
      if (this.newPlace) {
        this.$emit('saved').then(this.selectModalText('Заведение удалено'), this.selectShowModal(true)).catch((message) => { console.log(message, 'message'); });
      }
      if (!this.newPlace) {
        this.form.delete(`/places/${this.item.id}`).then((message) => {
          console.log(message, 'message');
          this.selectModalText('Заведение удалено'); this.selectShowModal(true); this.$emit('saved');
        });
        // .catch((ex)=>{console.log(ex.message, 'message');});
      }
    },
    changeName() {
      if (!this.mobile) {
        return;
      }
      if (!this.show) {
        this.show = true;
        return;
      }
      this.nameChanging = !this.nameChanging;
      setTimeout(() => this.$refs.namePlace.focus(), 10);
    },
  },

  computed: {
    rotateArrow() {
      return !this.show ? '' : 'rotate-arrow';
    },
    mobile: {
      cache: false,
      get() {
        return window.innerWidth < 840;
      },
    },
  },
};
</script>


<style scoped>
    .arrow {
        transition: 0.5s all;
    }

    .rotate-arrow {
        transform: rotate(180deg);
    }
    .team-input {
        margin-top: -1px;
    }
    .button-reg-modal {
      width: 90%;
      margin-right: 20px;
      margin-left: 20px;
     height: 40px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 45px;
      font-weight: bold;
      font-size: 14px;
  }
  .yellow {
      background-color:  #FFCE42;
  }
  .black-border {
 border: 1px solid black;
  }
</style>
